import request from '../../../utils/request';

async function deleteDocument(enrollmentId, documentId) {
  return request({
    url: `/enrollment/${enrollmentId}/documents/${documentId}`,
    method: 'DELETE',
  });
}

export default {
  deleteDocument,
};
